/*
 * LanguageChipInput Messages
 *
 * This contains all the text for the LanguageChipInput component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  languages: {
    id: 'app.components.LanguageChipInput.languages',
    defaultMessage: 'Languages',
  },
});
